import { CountriesModel } from "@app/redux/models";
import { Dispatch } from "redux";
import { getActiveOemCountries, getAll, getAllOemCountries } from "../../services/countries";
import { RETRIEVE_COUNTRIES } from "./types";

export const retrieveCountries =
    () =>
    async (dispatch: Dispatch): Promise<CountriesModel> => {
        try {
            const response = await getAll();

            dispatch({
                type: RETRIEVE_COUNTRIES,
                payload: response.data,
            });

            return Promise.resolve(response.data);
        } catch (err: any) {
            console.log(err.message);
            return Promise.reject(err);
        }
    };

export const retrieveOemCountries =
    (appId: string) =>
    async (dispatch: Dispatch): Promise<CountriesModel> => {
        try {
            const response = await getAllOemCountries(appId);

            dispatch({
                type: RETRIEVE_COUNTRIES,
                payload: response.data,
            });

            return Promise.resolve(response.data);
        } catch (err: any) {
            console.log(err.message);
            return Promise.reject(err);
        }
    };

export const retrieveOemActiveCountries =
    () =>
    async (dispatch: Dispatch): Promise<CountriesModel> => {
        try {
            const response = await getActiveOemCountries();

            dispatch({
                type: RETRIEVE_COUNTRIES,
                payload: response.data,
            });

            return Promise.resolve(response.data);
        } catch (err: any) {
            console.log(err.message);
            return Promise.reject(err);
        }
    };
